<template>
    <div>
        <div>
            <b-card-group deck v-if="!onlyForAccountant()" style="display: none;">
                <b-card
                    border-variant="success"
                    header="Показатель за месяц"
                    header-bg-variant="success"
                    header-text-variant="white"
                    align="center"
                >
                    <b-card-text>
                        <div class="row">
                            <div class="col-6">
                                <h5>5</h5>
                                <small>Заказов</small>
                            </div>
                            <div class="col-6">
                                <h5>60 000</h5>
                                <small>Рублей</small>
                            </div>
                        </div>
                    </b-card-text>
                </b-card>

                <b-card
                    border-variant="primary"
                    header="Показатель за квартал"
                    header-bg-variant="primary"
                    header-text-variant="white"
                    align="center"
                >
                    <b-card-text>
                        <div class="row">
                            <div class="col-6">
                                <h5>15</h5>
                                <small>Заказов</small>
                            </div>
                            <div class="col-6">
                                <h5>160 000</h5>
                                <small>Рублей</small>
                            </div>
                        </div>
                    </b-card-text>
                </b-card>

                <b-card
                    border-variant="success"
                    header="Показатель за год"
                    header-bg-variant="success"
                    header-text-variant="white"
                    align="center"
                >
                    <b-card-text>
                        <div class="row">
                            <div class="col-6">
                                <h5>50</h5>
                                <small>Заказов</small>
                            </div>
                            <div class="col-6">
                                <h5>1 600 000</h5>
                                <small>Рублей</small>
                            </div>
                        </div>
                    </b-card-text>
                </b-card>
            </b-card-group>
        </div>
        <tsoft-finance-finder-creator
            v-if="!isClientAccount"
            :key="componentRefreshKey"
            :isNeedCreate="false"
            :changed-item="changedItem"
            :additionalGetParameter="additionalGetParameter + '&headerName=tableHeadersWithOrder'"
            :typeOfTableFilter="$route.params.invoice_type ? '' : 'finance'"
        />
        <tsoft-finance-finder-creator-client
            v-if="isClientAccount"
            :key="componentRefreshKey"
            :isNeedCreate="false"
            :changed-item="changedItem"
            :additionalGetParameter="additionalGetParameter"
            :typeOfTableFilter="$route.params.invoice_type ? '' : 'finance'"
        />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import tsoftFinanceFinderAndCreator from '@/components/finance/FinanceFinderAndCreator.vue'
    import tsoftFinanceFinderAndCreatorClient from '@/components/finance/FinanceFinderAndCreatorClient.vue'

    export default {
        components: {
            'tsoft-finance-finder-creator': tsoftFinanceFinderAndCreator,
            'tsoft-finance-finder-creator-client': tsoftFinanceFinderAndCreatorClient
        },
        props: {
            changedItem: {
                type: Object,
                default: () => {}
            }
        },
        data() {
            return {
                additionalGetParameter: '',
                componentRefreshKey: 0,
            }
        },
        computed: {
            ...mapGetters("auth", ["currentUser"]),
            isClientAccount() {
                return this.currentUser.role.includes('client');
            },
        },
        created() {
            this.additionalGetParameterChanger()
        },
        watch: {
            '$route.path'() {
                this.additionalGetParameterChanger()
            }
        },
        methods: {
            additionalGetParameterChanger() {
                if (this.$route.params.invoice_type) {
                    this.additionalGetParameter = `&invoice_type=${this.$route.params.invoice_type}`
                } else {
                    this.additionalGetParameter = ''
                }
                this.componentRefreshKey += 1
            },
            onlyForAccountant() {
                if (this.currentUser.role && (this.currentUser.role.includes("administrator") ||
                    this.currentUser.role.includes("head-accountant") ||
                    this.currentUser.role.includes("accountant"))) {
                    return true
                }
                return false
            },
        }
    }
</script>
